// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__Z1fLh","alert":"SettungsInbox_alert__1BBEr"};